import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRegistroFattureVenditaStep2Component } from './conservazione-carica-documento-registro-fatture-vendita-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-registro-fatture-vendita-step2', {
            url: '/conservazione-carica-registro-fatture-vendita',
            ncyBreadcrumb: {
                label: 'Registro Fatture Vendita',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-registro-fatture-vendita-step2 flex="100"></conservazione-carica-documento-registro-fatture-vendita-step2>'
                }
            }
        });
};



stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroFattureVenditaStep2Module: string = ng
  .module('conservazione-carica-documento-registro-fatture-vendita-step2', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('conservazioneCaricaDocumentoRegistroFattureVenditaStep2', ConservazioneCaricaDocumentoRegistroFattureVenditaStep2Component)
  .config(stateConfig)
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-fatture-vendita-step2/conservazione-carica-documento-registro-fatture-vendita-step2.module.ts